import { FC } from 'react'
import styles from './index.module.scss'

type Props = {
  name: string
  isVerifiedAccount: boolean
}

export const VerifiedName: FC<Props> = ({ name = '', isVerifiedAccount = false }) => {
  return (
    <div className={styles.container}>
      <div className={styles.name}>{name}</div>
      {isVerifiedAccount && (
        <img src='/images/common/verified_account_icon.svg' alt='Verified account icon' className={styles.icon} />
      )}
    </div>
  )
}
